import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

import { CalculationService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { HelperService, HTTPService, DataService } from 'app/services';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { CommissionDetailsComponent } from '../commission-details/commission-details.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-estimate-profitability',
  templateUrl: './estimate-profitability.component.html',
  styleUrls: ['./estimate-profitability.component.scss'],
})
export class EstimateProfitabilityComponent implements OnInit, OnDestroy {
  @Input() profitabilityData = <any>{
    partPrice: 0,
    partCost: 0,
    laborPrice: 0,
    laborCost: 0,
    tirePrice: 0,
    tireCost: 0,
    hazmatFeePrice: 0,
    hazmatFeeCost: 0,
    otherPrice: 0,
    otherCost: 0,
    partProfit: 0,
    laborProfit: 0,
    tireProfit: 0,
    hazmatFeeProfit: 0,
    otherProfit: 0,
    totalProfit: 0,
    totalCost: 0,
    partMargin: 0,
    laborMargin: 0,
    tireMargin: 0,
    hazmatFeeMargin: 0,
    otherMargin: 0,
    totalMargin: 0,
    totalDiscount: 0,
    shopFee: 0,
    totalTax: 0,
    serviceLevelDiscount: 0,
  };
  @Input() isTireStorageEnabled: boolean = false;
  @Input() isRoLevelFeeEnabled: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() hideCost: boolean = true;
  @Input() estimate: any = '';
  @Input() isSubletTrackingEnabled: boolean = false;
  @Input('isPaidFull')
  set setIsPaidFull(isPaidFull: any) {
    if (isPaidFull) {
      this.getEarnedCommision()
    }
  }
  usd: string = currency.USD;
  selected: boolean = false;
  laborCostTooltip: string = `Based on planned labor cost to help <br/> with the estimate`;
  commisionEarned: any = '';
  techId: string = '';
  dataSubscription: Subscription;

  constructor(
    public calculationService: CalculationService,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    public helperService: HelperService,
    private httpService: HTTPService,
    private dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.setDataService();
    this.techId = this.helperService.getCompany().employeeId;
    if (this.estimate?.isPaidFull) {
      this.getEarnedCommision();
    }
  }

  setDataService() {
    this.dataSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'update-service-advisor') {
          this.commisionEarned = undefined;
          if (data.data.id === this.techId) {
            this.getEarnedCommision();
          }
        }
      }
    });

  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }

  /**
   * Get color class based on if number is positive or negative
   */
  getColorClass(val) {
    return val < 0 ? 'setParens' : 'text-green';
  }

  getCommissionColorClass(val) {
    return 'text-green';
  }

  /**
   * Convert to positive
   * @param val
   */
  positive(val: number) {
    return val < 0 ? val * -1 : val;
  }

  getEarnedCommision() {
    const orderId = this.activatedRoute.snapshot.paramMap.get('id') || this.estimate._id;

    if (orderId && this.techId && this.techId === this.estimate?.serviceWriter?.serviceWriterId) {
      this.httpService.getEarnedCommission(orderId, this.techId).then(
        (result) => {
          this.commisionEarned = result.commissionResponse;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  openCommissionDetailDialog() {
    if (this.isCommissionPlanEnabled) {
      const ref = this.dialogService.open(CommissionDetailsComponent, {
        width: '1200px',
        styleClass: 'add-dialog commission-detail-dialog',
        showHeader: false,
        data: {
          orderId: this.estimate._id,
          orderCode: this.estimate.code,
        },
      });
    }
  }


  /**
   *
   * @param val value
   * @param type currency / percentage
   */
  formatField(val: number, type: string) {
    let finalStr =
      type === 'currency'
        ? this.currencyPipe.transform(this.calculationService.roundOff(val < 0 ? val * -1 : val), this.usd)
        : this.decimalPipe.transform(this.calculationService.roundOff((val < 0 ? val * -1 : val) * 100), '2.1-1');

    return val < 0 ? `(${finalStr})` : finalStr;
  }

  onTabClose() {
    this.selected = !this.selected;
  }
}
